export const MentionSymbol = {
    user: '@',
    tag: '#',
};
export const MentionRegex = new RegExp(`([${Object.values(MentionSymbol).join(',')}])\\[([\\p{L}\\p{M}\\p{N}_\\s\\-]+)\\]\\(([A-Za-z0-9\\-_]+)\\)`, 'gu');
export const ObfuscatedMentionRegex = new RegExp(`([${Object.values(MentionSymbol).join(',')}])\\(([\\p{L}\\p{M}\\p{N}_\\s\\-]+)\\)\\(([A-Za-z0-9\\-_]+)\\)`, 'gu');
//# sourceMappingURL=constants.js.map